<!-- Overlay -->
<div
  class="relative overflow-x-hidden overflow-y-auto"
  [ngClass]="{
    'pointer-events-none after:absolute after:w-full after:opacity-90 after:z-[100] after:top-0 after:bottom-0 after:right-0 after:left-0 after:bg-white transition-opacity':
      showOverlay
  }"
  [style.maxHeight]="maxHeight"
>
  <!-- PDF viewer canvas -->
  <canvas #pdfCanvas></canvas>
</div>
